import { i18n } from '@/plugins/i18n'

export const merchantType = {
    REAL: 0,
    LEGAL: 1,
}

export const merchantTypeStr = {
    REAL: i18n.t('merchant_type.real'),
    LEGAL: i18n.t('merchant_type.legal'),

    get(type) {
        let type_str = null;
        Object.keys(merchantType).forEach(function (item) {
            if(merchantType[item] === type) {
                type_str = merchantTypeStr[item]
            }
        })

        return type_str
    }
}